module.exports = __webpack_public_path__ + "img/client (2).b3c90d64.jpg";